export function SageStatusBadge({ status, testId, size = "md" }) {
  const map = {
    CONNECTED: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
    DEGRADED: "bg-amber-500/15 text-amber-400 border-amber-500/40",
    DISCONNECTED: "bg-rose-500/15 text-rose-400 border-rose-500/40",
  };
  const dot = { CONNECTED: "bg-emerald-400", DEGRADED: "bg-amber-400", DISCONNECTED: "bg-rose-400" };
  const pad = size === "lg" ? "px-4 py-2 text-sm" : "px-3 py-1.5 text-xs";
  return (
    <span data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border font-semibold uppercase tracking-wider ${pad} ${map[status] || map.DISCONNECTED}`}>
      <span className={`h-2 w-2 rounded-full mc-pulse-dot ${dot[status] || dot.DISCONNECTED}`} />
      {status || "UNKNOWN"}
    </span>
  );
}
